import React from 'react';
import { Image } from 'rebass/styled-components';
import Icon from '../../../../assets/icon-google-small.svg';

export const GoogleIcon = () => <Image src={Icon} alt="Google" width="24px" height="24px" />;
